import { apiSlice } from 'api/apiSlice'
import CMSSectionType from 'shared/enums/CMSSectionType'

export type Section = {
  id: number
  type: CMSSectionType
  uuid: string
}

export type GetCMSArticle = {
  category: string
  id: number
  sections: Section[]
  slug: string
  uuid: string
}

const cmsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCMSArticle: builder.query<GetCMSArticle, string>({
      query: (article) => ({
        app: 'cms',
        method: 'GET',
        url: `/web-api/v1/cms/cms_articles/${article}`,
      }),
    }),
  }),
})

export const { useLazyGetCMSArticleQuery } = cmsApi
